<section class="container">
  <mat-card *ngFor="let item of data | keyvalue">
    <mat-card-header>
      <img mat-card-avatar src="{{item.value.user.profile_image_url}}"
      (error)="handleError($event)">
      <mat-card-title>{{item.value.user.name}}
        <a class="external-site"
        color="link"
        href="https://www.twitter.com/{{item.value.user.screen_name}}"
        target="_blank"> @{{item.value.user.screen_name}}
      </a>
      <span class="date">on {{item.value.created_at | date: 'medium'}}</span>

    </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <a  href="https://twitter.com/i/web/status/{{item.key}}"
      target="_blank"
      class="content external-site"
      [innerHtml]="linkify(item.value.text)">
      </a>
    </mat-card-content>
  </mat-card>

  <mat-paginator
    [pageIndex]="page"
    [length]="1000"
    [pageSize]="itemsPerPage"
    (page)="moreData($event)">
  </mat-paginator>
</section>
